import React from "react"
export function TextField({ value }: { value: string | undefined }): JSX.Element {
  return <div className={'flex items-center text-base lg:text-lg text-cents-black h-10 w-fit'}>{value}</div>
}